<template>
  <div style="width: 100%">
    <v-sheet
      tile
      height="54"
      class="d-flex"
    >
      <v-btn
        icon
        class="ma-2"
        color="primary"
        @click="$refs.calendar.prev()"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-col
        style="min-width: 150px;max-width: 130px"
      >
        <template>
          <v-text-field
            id="sDate"
            v-model="focusDate"
            :label="$t('date')"
            :rules="[v => !!v || $t('is-required')]"
            clear-icon="flaticon2-close-cross"
            outlined
            dense
            clearable
          />
          <date-picker
            v-model="focusDate"
            element="sDate"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            auto-submit
            :min="$store.state.startDate"
            :max="$store.state.endDate"
            :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
            @close="setDate"
          />
        </template>
      </v-col>
      <v-select
        v-model="type"
        :items="types"
        dense
        outlined
        hide-details
        item-value="value"
        item-text="text"
        class="mt-2 pt-1"
        :label="$t('viewType')"
        style="max-width: 150px"
      />
      <v-text-field
        v-show="!isMobile"
        v-model="intervalHeight"
        :label="$t('intervalHeight')"
        height="20"
        dense
        outlined
        class="pt-1 mt-2 ms-3 dense"
        type="number"
        :rules="numberRules"
        @focus="focusEvent"
        style="max-width: 120px"
      />
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!selectedMoveStatus && !typeProp"
            icon
            class="ma-2"
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="selectedMoveStatus = 'create'"
          >
            <v-icon>mdi-table-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('makeEvent') }}</span>
      </v-tooltip>
      <v-chip
        v-if="selectedMoveStatus == 'create'"
        outlined
      >
        {{ $t('forCreateClickOnCalenderInCategoryMode') }}
      </v-chip>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="mt-5 mx-0"
            color="primary"
            x-small
            v-on="on"
            @click="filter = true"
          >
            <v-icon>
              mdi-filter-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('filter') }}</span>
      </v-tooltip>
      <v-btn
        icon
        class="ma-2"
        color="primary"
        @click="$refs.calendar.next()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </v-sheet>
    <v-sheet :height="(heightProp ? heightProp : '300')">
      <v-calendar
        ref="calendar"
        v-model="focus"
        style="border-bottom: #e0e0e0 1px solid;"
        locale="fa"
        :weekdays="weekday"
        :type="type"
        :events="events"
        :weekday-format="getDay"
        event-overlap-mode="column"
        :event-overlap-threshold="60"
        :categories="categories"
        category-show-all
        category-text="name"
        :hide-header="false"
        @change="getEvents"
        @mousedown:event="startDrag"
        @mousedown:time-category="startTimeEvent"
        @mousemove:time-category="mouseMove"
        @mouseup:time-category="endDrag"
        @mousedown:time="startTimeEvent"
        @mousemove:time="mouseMove"
        @mouseup:time="endDrag"
        @click:event="showEvent"
        @click:more="viewDay"
        @click:date="viewDay"
        @mouseleave.native="cancelDrag"
        :interval-height="intervalHeight"
      >
        <template
          v-slot:day-label-header="{}"
        >
<!--          <v-row style="height: 50px ;" />-->
        </template>
<!--                <template v-slot:day-header="{}">-->
<!--                  <v-row style="height: 50px">-->
<!--                  </v-row>-->
<!--                </template>-->
        <template v-slot:event="{ event, eventParsed, timed, eventSummary }">
          <session
            :event="event"
            :timed="timed"
            :event-parsed="eventParsed"
            :event-summary="eventSummary"
            @extendBottom="extendBottom"
          />
        </template>
      </v-calendar>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
        v-model="selectedOpen"
        width="500px"
      >
        <session-modal
          :selected-event="selectedEvent"
          @close="selectedOpen = false"
          @setMoveStatus="setMoveStatus"
          @removeEvent="removeEvent"
          @updateTeacher="updateTeacher"
          @updateStatus="updateStatusTrigger"
        />
      </v-dialog>
    </v-sheet>
    <v-snackbar
      v-model="snackbar"
      :color="(snackbarColor ? snackbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = !snackbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
          <autocomplete
            v-model="branch"
            :title="$t('branch')"
            type="branch"
            :value="branch"
          />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="place"
              title="academyPlace"
              type="academyPlace"
              :multiple="true"
            />
          </v-col>
          <v-col
            v-if="!$store.state.accessType"
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="teacher"
              title="teacher"
              type="person"
              :new-btn="true"
              :data="JSON.stringify({type: 'teacher'})"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getEvents"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Session from './session'
  import SessionModal from './sessionModal'
  import aicomplete from '../../../components/general/AIcomplete/index'
  export default {
    name: 'AcademyCalender',
    components: {
      aicomplete,
      Session,
      SessionModal,
    },
    props: ['eventsProp', 'startTime', 'teacherProp', 'placeProp', 'typeProp', 'heightProp'],
    data: () => ({
      focus: '',
      numberRules: [
        v => !!v || 'This field is required',
        v => (v && v >= 0) || 'The number must be bigger than zero',
      ],
      intervalHeight: 48,
      branch: null,
      focusDate: null,
      type: 'week',
      types: ['week', '4day'],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [6, 0, 1, 2, 3, 4, 5],
      categories: [],
      weekdays: [
        { text: 'Sun - Sat', value: [6, 0, 1, 2, 3, 4, 5] },
        { text: 'Mon - Sun', value: [6, 0, 1, 2, 3, 4, 5] },
        { text: 'Mon - Fri', value: [6, 0, 1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      value: '',
      filter: false,
      editName: false,
      snackbar: false,
      snackbarColor: null,
      teacher: null,
      place: null,
      allPlace: null,
      snackbarText: null,
      weekEvents: null,
      selectedEvent: {},
      tempEvent: {},
      selectedElement: null,
      updateStatus: false,
      selectedOpen: false,
      selectedMoveStatus: null,
      timer: 0,
      events: [],
    }),
    watch: {
      eventsProp () {
        this.events = [
          ...this.weekEvents,
          ...Array.from(this.eventsProp),
        ]
        this.$refs.calendar.scrollToTime(this.startTime)
      },
      placeProp () {
        this.getEvents({})
      },
      place (val) {
        this.categories = this.allPlace
        if (val && val.length > 0) {
          this.categories = val
        }
      },
    },
    beforeMount () {
      if (this.typeProp) {
        this.type = this.typeProp
      }
    },
    activated: function () {
      if (this.events.length > 0) {
        this.$refs.calendar.scrollToTime(this.events[0].start_time)
      }
    },
    mounted () {
      this.types = [
        {
          value: 'week',
          text: this.$t('week'),
        },
        {
          value: 'category',
          text: this.$t('daily'),
        },
        {
          value: '4day',
          text: this.$t('4day'),
        },
      ]
      this.selectedMoveStatus = null
      this.getPlaces()
    },
    methods: {
      setDate: function () {
        var m = this.$moment()
        this.focus = this.$moment(this.focusDate, 'jYYYY/jM/jD').format('YYYY-MM-DD')
        if (!this.focusDate) {
          var today = ''
          if (this.$store.state.date_locale === 'fa,en') {
            today = m.format('jYYYY/jMM/jDD')
          }
          if (this.$store.state.date_locale === 'en,fa') {
            today = m.format('YYYY/MM/DD')
          }
          if (today < this.$store.state.startDate) {
            today = this.$store.state.startDate
          }
          if (today > this.$store.state.endDate) {
            today = this.$store.state.endDate
          }
          this.focusDate = today
          return today
        }
      },
      removeEvent () {
        const i = this.events.indexOf(this.selectedEvent)
        this.selectedOpen = false
        if (i !== -1) {
          this.deleteEvent(this.selectedEvent)
          this.events.splice(i, 1)
        }
        this.selectedEvent = {}
        this.selectedMoveStatus = null
      },
      setMoveStatus (status) {
        this.selectedMoveStatus = status
        this.selectedOpen = false
      },
      viewDay ({ date, y }) {
        this.focus = date
        this.type = 'category'
      },
      showEvent ({ nativeEvent, event }) {
        var app = this
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(function () {
            app.selectedOpen = true
          }))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(function () {
            open()
          }))
        } else {
          open()
        }
        nativeEvent.stopPropagation()
      },
      getDay (date) {
        var m1 = this.$moment(date.date)
        var format = 'dddd - D MMM'
        var locale = 'en'
        if (this.$store.state.date_locale === 'fa,en') {
          format = 'dddd - jD jMMM'
          locale = 'fa'
        }
        return m1.locale(locale).format(format)
      },
      getPlaces () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'getdetail', {
          params: {
            select: 'academyPlacesAll',
          },
        })
          .then(res => {
            res = res.data
            app.allPlace = res
            app.categories = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      getEvents ({ start, end }) {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            getEvents: 'active',
            start: (start ? start.date : null),
            end: (end ? end.date : null),
            teacherAccess: (app.$store.state.teacherAccess === 'active' ? 'active' : null),
            teacher: (app.teacherProp ? app.teacherProp : app.teacher),
            place: (app.teacherProp ? app.teacherProp : app.place),
            branch: app.branch,
            mode: app.type,
          },
        })
          .then(res => {
            res = res.data
            app.weekEvents = res
            app.events = [
              ...Array.from(res),
              ...(app.eventsProp ? app.eventsProp : []),
            ]
            app.$refs.calendar.scrollToTime((app.events && app.events[0] !== undefined ? app.events[0].start_time : '12:00'))
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      getEventColor (event) {
        return event.color
      },
      startDrag ({ event, timed }) {
        if (event && timed && !event.status && this.$store.state.admin === 'active') {
          this.dragEvent = event
          this.dragTime = null
          this.extendOriginal = null
        }
      },
      startTimeEvent (tms) {
        if (this.$store.state.admin === 'active') {
          const mouse = this.toTime(tms)
          var category = tms.category
          if (this.dragEvent && this.dragTime === null && !this.dragEvent.status) {
            const start = this.dragEvent.start
            this.dragTime = mouse - start
          } else {
            if (this.selectedMoveStatus === 'copy' || this.selectedMoveStatus === 'move') {
              if (this.selectedEvent && this.selectedEvent.name !== undefined) {
                this.makeEvent(mouse, category)
              }
            }
            if (this.selectedMoveStatus === 'create' && this.eventsProp) {
              this.selectedEvent = this.eventsProp[0]
              this.selectedEvent.category = this.placeProp.name
              this.makeEvent(mouse, category)
            }
          }
        }
      },
      updateTeacher (data) {
        const i = this.events.indexOf(data.event)
        this.events[i].teacher = data.teacher
        this.events[i].teacher_id = data.teacher.id
        this.events[i].teacher_cost = data.teacher_cost
      },
      updateEvent (event) {
        var app = this
        app.loading = true
        app.$axios.put(this.$endpoint + 'academySession/' + event.id, event)
          .then(res => {
            res = res.data
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      storeEvent (event, j) {
        var app = this
        app.loading = true
        app.$axios.post(this.$endpoint + 'academySession', event)
          .then(res => {
            res = res.data.data
            app.events[j].id = res.id
            app.createEvent = null
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      deleteEvent (event) {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'academySession/' + event.id, event)
          .then(res => {
            res = res.data
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      makeEvent (mouse, category) {
        if (this.selectedEvent && this.selectedEvent.name !== undefined) {
          this.createStart = this.roundTime(mouse)
          var duration = this.selectedEvent.end - this.selectedEvent.start
          this.createEvent = {
            name: this.selectedEvent.name + (this.selectedMoveStatus === 'copy' ? ' - copy' : ''),
            color: this.selectedEvent.color,
            date: this.selectedEvent.date,
            id: this.selectedEvent.id,
            copiedId: this.selectedEvent.id,
            teacher_cost: this.selectedEvent.teacher_cost,
            teacher: this.selectedEvent.teacher,
            event_id: this.selectedEvent.event_id,
            start: this.createStart,
            startOriginal: this.createStart,
            end: +this.createStart + +duration,
            endOriginal: +this.createStart + +duration,
            timed: true,
            category: (category !== undefined ? category.name : this.selectedEvent.category),
          }
          this.events.push(this.createEvent)
          const i = this.events.indexOf(this.selectedEvent)
          if (this.selectedMoveStatus === 'move') {
            if (i !== -1) {
              this.events.splice(i, 1)
            }
            this.updateEvent(this.createEvent)
          }
          const j = this.events.indexOf(this.createEvent)
          if (this.selectedMoveStatus === 'copy') {
            this.storeEvent(this.createEvent, j)
          }
          this.overlapCheck(this.createEvent, j)
          this.selectedEvent = {}
          this.selectedMoveStatus = null
        }
      },
      updateStatusTrigger (status) {
        this.selectedEvent.status = status
      },
      extendBottom (event) {
        if (!event.status && this.$store.state.admin === 'active') {
          this.createEvent = event
          this.createStart = event.start
          this.extendOriginal = event.end
          this.updateStatus = true
        }
      },
      mouseMove (tms) {
        var app = this
        const mouse = this.toTime(tms)
        if (this.dragEvent && this.dragTime !== null) {
          const i = this.events.indexOf(this.dragEvent)
          const start = this.dragEvent.start
          const end = this.dragEvent.end
          const duration = end - start
          const newStartTime = mouse - this.dragTime
          const newStart = this.roundTime(newStartTime)
          const newEnd = newStart + duration
          this.dragEvent.start = newStart
          this.dragEvent.end = newEnd
          clearTimeout(this.timer)
          var event = this.dragEvent
          this.updateStatus = true
          this.timer = setTimeout(function () {
            app.overlapCheck(event, i)
          }, 1000)
        } else if (this.createEvent && this.createStart !== null) {
          const mouseRounded = this.roundTime(mouse, false)
          const min = Math.min(mouseRounded, this.createStart)
          const max = Math.max(mouseRounded, this.createStart)
          this.createEvent.start = min
          this.createEvent.end = max
        }
      },
      overlapCheck (event, i) {
        const start = event.start
        const end = event.end
        var app = this
        var check = true
        for (var index = 0; index < this.events.length; index++) {
          var value = this.events[index]
          if (index !== i && value.category === event.category) {
            if (start >= value.start && start < value.end) {
              check = false
            }
            if (end > value.start && end <= value.end) {
              check = false
            }
          }
          if (!check && i !== index) {
            app.snackbarText = app.$t('overlap') + ' ' + event.name + ' ' + app.$t('with') + ' ' + value.name
            app.snackbarColor = 'pink'
            app.snackbar = true
            if (event.startOriginal) {
              event.start = event.startOriginal
              event.end = event.endOriginal
            } else {
              app.events.splice(i, 1)
            }
            app.updateEvent(event)
            break
          }
        }
        if (check) {
          event.startOriginal = start
          event.endOriginal = end
        }
      },
      endDrag () {
        if (this.dragEvent && this.dragEvent.id && this.updateStatus) {
          this.updateEvent(this.dragEvent)
        }
        if (this.createEvent && this.createEvent.id && this.updateStatus) {
          this.updateEvent(this.createEvent)
        }
        this.dragTime = null
        this.dragEvent = null
        this.createEvent = null
        this.updateStatus = false
        this.createStart = null
        this.extendOriginal = null
      },
      cancelDrag () {
        if (this.createEvent) {
          if (this.extendOriginal) {
            this.createEvent.end = this.extendOriginal
          } else {
            const i = this.events.indexOf(this.createEvent)
            if (i !== -1) {
              this.events.splice(i, 1)
            }
          }
        }
        this.createEvent = null
        this.createStart = null
        this.dragTime = null
        this.dragEvent = null
        this.updateStatus = false
      },
      roundTime (time, down = true) {
        const roundTo = 15 // minutes
        const roundDownTime = roundTo * 60 * 1000
        return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
      },
      toTime (tms) {
        return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
      },
    },
  }
</script>

<style scoped>
.v-calendar-daily__head {
  margin-left: 17px !important;
  margin-right: 0px !important;
}
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;
}
.v-event-drag-bottom::after {
   display: none;
   position: absolute;
   left: 50%;
   height: 4px;
   border-top: 1px solid white;
   border-bottom: 1px solid white;
   width: 16px;
   margin-left: -8px;
   opacity: 0.8;
   content: '';
 }

.v-event-drag-bottom:hover::after {
   display: block;
 }
.v-event-draggable {
  white-space: normal !important;
  padding: 3px 5px;
  font-size: 11px;
}
</style>
